export default __webpack_public_path__ + "static/accents-avoid-yellow-do-light-913636bea3497eab03b23af6661ba620.png";